import styled from '@emotion/styled';
import { Modal, Typography } from '@innovamat/glimmer-components';
import { Trans, useTranslation } from 'react-i18next';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const StyledUl = styled.ul`
  padding-left: 24px;
  margin: 8px 0;
`;

const StyledLi = styled.li`
  margin: 4px 0;
`;

type Props = {
  isOpen: boolean;
  onClose?: () => void;
  onContactAdvisor?: () => void;
};

function RequestHomeAccessModal({
  isOpen,
  onClose,
  onContactAdvisor,
}: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalWidth={692}
      title={t('students.home-access-popup.configuration.title')}
      buttons={[
        {
          dataTestId: 'assessor',
          children: t('innovacomponents.userPopUp.contactYourAssessor'),
          onClick: onContactAdvisor,
          variant: 'accent',
        },
        {
          children: t('confirmModal.action.cancel'),
          onClick: onClose,
          variant: 'tertiary',
        },
      ]}
    >
      <ModalContent>
        <Typography.Body1>
          <Trans
            i18nKey="students.home-access-popup.configuration.description"
            components={{
              ul: <StyledUl />,
              li: <StyledLi />,
              b: <b />,
              br: <br />,
            }}
          />
        </Typography.Body1>
      </ModalContent>
    </Modal>
  );
}

export { RequestHomeAccessModal };
